import ModuleModel from 'models/ModuleModel'

export default class ModulesCollection extends Backbone.Collection {

    get model() {
        return ModuleModel
    }

}
